/* Email popup: scratch card, claim, email step, thank-you step (sections/email-popup.liquid) */
(function () {
  var CLOSED = 'epop_closed';
  var DONE = 'epop_done';

  function get(k) {
    try {
      return localStorage.getItem(k);
    } catch (e) {
      return null;
    }
  }

  function set(k, v) {
    try {
      localStorage.setItem(k, v);
    } catch (e) {}
  }

  function setup(root) {
    if (root.__epop) return;
    root.__epop = true;

    var delay = (+root.getAttribute('data-delay') || 0) * 1000;
    var days = +root.getAttribute('data-days') || 7;
    var card = root.querySelector('[data-epop-card]');
    var cvs = root.querySelector('[data-epop-scratch]');
    var posted = !!root.querySelector('[data-epop-posted]');
    var failed = !!root.querySelector('.epop__err');
    var forced = /[?&]popup=1(&|$)/.test(location.search);
    var designMode = !!(window.Shopify && Shopify.designMode);
    var ctx = null;
    var w = 0;
    var h = 0;
    var drawing = false;
    var last = null;
    var lastCheck = 0;
    var finished = false;
    var isOpen = false;
    var lastFocus = null;

    function state(s) {
      root.setAttribute('data-state', s);
    }

    function focusStep() {
      var s = root.getAttribute('data-state');
      var el = null;
      if (s === 'scratch') el = cvs;
      if (s === 'claim') el = root.querySelector('[data-epop-claim]');
      if (s === 'email') el = root.querySelector('.epop__input');
      if (s === 'done') el = root.querySelector('[data-epop-copy]') || root.querySelector('[data-only~="done"] a, [data-only~="done"] button');
      if (el && el.focus) el.focus({ preventScroll: true });
    }

    function paint() {
      if (!cvs || ctx || finished) return;
      var r = cvs.getBoundingClientRect();
      if (!r.width) return;
      var d = Math.min(window.devicePixelRatio || 1, 2);
      w = r.width;
      h = r.height;
      cvs.width = Math.round(w * d);
      cvs.height = Math.round(h * d);
      ctx = cvs.getContext('2d', { willReadFrequently: true });
      ctx.setTransform(d, 0, 0, d, 0, 0);
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#e8d48a');
      g.addColorStop(0.28, '#c6a547');
      g.addColorStop(0.5, '#efe0a2');
      g.addColorStop(0.75, '#b98f35');
      g.addColorStop(1, '#dcc272');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
      for (var i = 0; i < 2200; i++) {
        ctx.fillStyle = Math.random() < 0.5 ? 'rgba(255,255,255,.14)' : 'rgba(110,80,10,.12)';
        ctx.fillRect(Math.random() * w, Math.random() * h, 1 + Math.random() * 1.5, 1 + Math.random() * 1.5);
      }
      ctx.font = '600 ' + Math.round(w * 0.085) + 'px Outfit, Arial, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = 'rgba(255,255,255,.55)';
      ctx.fillText(cvs.getAttribute('data-label') || '', w / 2, h / 2);
    }

    function reveal() {
      if (finished) return;
      finished = true;
      drawing = false;
      if (card) card.classList.add('is-done');
      state('claim');
      setTimeout(focusStep, 450);
    }

    function check() {
      if (finished || !ctx) return;
      var cw = cvs.width;
      var ch = cvs.height;
      var data;
      try {
        data = ctx.getImageData(0, 0, cw, ch).data;
      } catch (e) {
        return;
      }
      var clear = 0;
      var total = 0;
      for (var y = 0; y < ch; y += 8) {
        for (var x = 0; x < cw; x += 8) {
          total++;
          if (data[(y * cw + x) * 4 + 3] < 40) clear++;
        }
      }
      if (clear / total > 0.45) reveal();
    }

    function pos(e) {
      var r = cvs.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }

    function line(a, b) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.lineWidth = Math.max(34, w * 0.11);
      ctx.beginPath();
      ctx.moveTo(a.x, a.y);
      ctx.lineTo(b.x, b.y);
      ctx.stroke();
    }

    function stop() {
      if (!drawing) return;
      drawing = false;
      check();
    }

    if (cvs) {
      cvs.addEventListener('pointerdown', function (e) {
        if (!ctx || finished) return;
        drawing = true;
        last = pos(e);
        line(last, { x: last.x + 0.1, y: last.y });
        try {
          cvs.setPointerCapture(e.pointerId);
        } catch (err) {}
        e.preventDefault();
      });
      cvs.addEventListener('pointermove', function (e) {
        if (!drawing) return;
        var p = pos(e);
        line(last, p);
        last = p;
        var now = Date.now();
        if (now - lastCheck > 120) {
          lastCheck = now;
          check();
        }
      });
      cvs.addEventListener('pointerup', stop);
      cvs.addEventListener('pointercancel', stop);
      cvs.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          reveal();
        }
      });
    }

    function open() {
      if (isOpen) return;
      root.hidden = false;
      if (!root.getClientRects().length) {
        root.hidden = true;
        return;
      }
      isOpen = true;
      lastFocus = document.activeElement;
      document.documentElement.classList.add('epop-lock');
      paint();
      void root.offsetWidth;
      root.classList.add('is-in');
      setTimeout(focusStep, 80);
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-in');
      document.documentElement.classList.remove('epop-lock');
      if (!posted && !designMode) set(CLOSED, String(Date.now()));
      setTimeout(function () {
        if (!isOpen) root.hidden = true;
      }, 360);
      if (lastFocus && lastFocus.focus) {
        try {
          lastFocus.focus({ preventScroll: true });
        } catch (e) {}
      }
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-epop-close],[data-epop-claim],[data-epop-copy]') : null;
      if (!t) return;
      if (t.hasAttribute('data-epop-close')) {
        close();
      } else if (t.hasAttribute('data-epop-claim')) {
        state('email');
        setTimeout(focusStep, 40);
      } else {
        var code = (root.querySelector('[data-epop-code]') || {}).textContent || '';
        var done = function () {
          t.textContent = t.getAttribute('data-done') || t.textContent;
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          document.body.appendChild(ta);
          ta.select();
          try {
            document.execCommand('copy');
          } catch (err) {}
          document.body.removeChild(ta);
          done();
        }
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var items = [].filter.call(root.querySelectorAll('button, a[href], input, [tabindex="0"]'), function (n) {
        return !n.disabled && n.offsetParent !== null && getComputedStyle(n).visibility !== 'hidden';
      });
      if (!items.length) return;
      var first = items[0];
      var lastEl = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        lastEl.focus();
      } else if (!e.shiftKey && document.activeElement === lastEl) {
        e.preventDefault();
        first.focus();
      }
    });

    function section() {
      return root.closest('.shopify-section');
    }

    document.addEventListener('shopify:section:select', function (e) {
      if (section() && section() === e.target) open();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (section() && section() === e.target) close();
    });

    if (posted) {
      finished = true;
      set(DONE, '1');
      state('done');
      open();
    } else if (failed) {
      finished = true;
      state('email');
      open();
    } else if (forced) {
      setTimeout(open, 300);
    } else if (!designMode) {
      if (get(DONE)) return;
      var t = +get(CLOSED);
      if (t && Date.now() - t < days * 864e5) return;
      setTimeout(open, delay);
    }
  }

  function init() {
    var list = document.querySelectorAll('[data-epop]');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();